<template>
  <a
    v-if="current_profile && current_profile.type !== PROFILE_TYPES.EMPLOYEE"
    data-test="sidebar-notifications-user"
    @click="toggleSidebar"
  >
    <OverlayBadge
      v-if="show_notification_point"
      class="mr-3"
      data-test="notifications-number"
      severity="danger"
      size="small"
    >
      <span class="p-0 md:!p-3 md:bg-gray-200 rounded-full text-gray-500 notification-bell cursor-pointer md:shadow-md">
        <FontAwesomeIcon
          :icon="['far', 'bell']"
          size="lg"
        />
      </span>
    </OverlayBadge>
    <div v-else>
      <span class="p-3 md:bg-gray-200 rounded-full text-gray-500 notification-bell cursor-pointer md:shadow-md">
        <FontAwesomeIcon
          :icon="['far', 'bell']"
          size="lg"
        />
      </span>
    </div>
  </a>
  <div
    v-else
    data-test="sidebar-notifications-user"
  >
    <a @click="toggleSidebar">
      <OverlayBadge
        v-if="show_notification_point"
        data-test="notifications-number"
        severity="danger"
        size="small"
      >
        <FontAwesomeIcon
          :class="[current_profile.type === PROFILE_TYPES.PARTNER ? '!text-gray-500' : '!text-white']"
          :icon="['far', 'bell']"
        />
      </OverlayBadge>
      <div v-else>
        <FontAwesomeIcon
          :class="[current_profile.type === PROFILE_TYPES.PARTNER ? '!text-gray-500' : '!text-white']"
          :icon="['far', 'bell']"
          data-test="notifications-number"
        />
      </div>
    </a>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import SIDEBAR_NOTIFICATIONS from '@/app/data/sidebar_constants';

const store = useStore();

const current_profile = computed(() => store.getters.current_profile);
const notifications_sidebar_last_opened_at = computed(() => store.getters.notifications_sidebar_last_opened_at);
const sidebar_type = computed(() => store.getters.sidebar_type);

onMounted(() => {
  store.dispatch('INIT_NOTIFICATIONS_LAST_OPENED');
});

const show_notification_point = computed(() => {
  const notified_at = _.get(current_profile.value, 'attributes.notified_at', new Date(0).toISOString());
  return notified_at > notifications_sidebar_last_opened_at.value;
});

const toggleSidebar = () => {
  if (sidebar_type.value === SIDEBAR_NOTIFICATIONS) {
    store.dispatch('SHOW_SIDEBAR', null);
  } else {
    store.dispatch('SHOW_SIDEBAR', SIDEBAR_NOTIFICATIONS);
  }
};
</script>

<style>
[data-badge]::after {
  box-shadow: none !important;
}

.notification-bell {
  transition: transform 0.2s ease-in-out;
}

.notification-bell:hover {
  animation: wiggle 0.5s ease-in-out;
}

@keyframes wiggle {
  0%,
  100% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-5deg);
  }

  75% {
    transform: rotate(5deg);
  }
}
</style>
